import React, { useReducer, createContext } from 'react';
import type {
  DeadlinesState,
  DeadlinesAction,
  DeadlinesContextValue,
} from '../types';

const DeadlinesContext = createContext<DeadlinesContextValue>(undefined as any);

const initialState: DeadlinesState = {
  search: '',
  filters: {
    client: null,
    assignee: null,
    projectLead: null,
    deadline: 0,
  },
};

export const ACTIONS = {
  SET_FILTERS: 'SET_FILTERS' as const,
  SET_SEARCH: 'SET_SEARCH' as const,
  CLEAR_FILTERS: 'CLEAR_FILTERS' as const,
};

const reducer = (
  state: DeadlinesState = initialState,
  { type, value }: DeadlinesAction,
): DeadlinesState => {
  switch (type) {
    case ACTIONS.SET_FILTERS:
      return { ...state, filters: value };
    case ACTIONS.CLEAR_FILTERS:
      return { ...state, filters: initialState.filters };
    case ACTIONS.SET_SEARCH:
      return { ...state, search: value };
    default:
      return state;
  }
};

function DeadlinesProvider(props: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <DeadlinesContext.Provider value={value}>
      {props.children}
    </DeadlinesContext.Provider>
  );
}

export { DeadlinesContext, DeadlinesProvider };
